import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { UserSettings } from '@models/core';
import { AUTH_TOKEN, DIALOG_SIZE, SMALL_DIALOG_SIZE, TENANT } from '@shared/consts';
import { InfoDialog } from '@shared/dialogs/info-dialog/info-dialog.component';
import { UserStore } from '@signal-store/user.store';
import { BREAKPOINTS } from 'src/app-breakpoints.module';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private userStore = inject(UserStore);
  private dialog = inject(MatDialog);
  private loadingDialogRef = null;

  getUserSettings(): UserSettings {
    return this.userStore.calculatedUserSettings();
  }

  getUserHeaders() {
    return {
      Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN),
      TenantId: sessionStorage.getItem(TENANT),
    };
  }

  getResponsiveDialogSize(): typeof DIALOG_SIZE {
    const windowWidth = window.innerWidth;
    const { full, lg, md, xl } = DIALOG_SIZE;
    const { mob_md, mob_sm } = SMALL_DIALOG_SIZE;
    if (windowWidth < BREAKPOINTS.sm) {
      return { full, xl, lg, md: lg, sm: mob_md, xs: mob_sm };
    }
    if (windowWidth < BREAKPOINTS.md) {
      return { full, xl, lg: xl, md: lg, sm: mob_md, xs: mob_sm };
    }
    return DIALOG_SIZE;
  }

  /**
   * Open a loading dialog that cannot be closed by the user.
   * Will block user interaction until closed programmatically by calling thisService.closeLoadingDialog().
   * @param type The type of loading message to show. The translation key used will be `messages.loading.${type}`. Default is 'save'.
   */
  openLoadingDialog(type = 'save') {
    this.loadingDialogRef = this.dialog.open(InfoDialog, {
      panelClass: ['cipo', 'cipo-dialog', 'classic'],
      ...this.getResponsiveDialogSize().sm,
      disableClose: true,
      data: {
        title: 'general.loadingMessage',
        description: `messages.loading.${type}`,
      },
    });
  }

  closeLoadingDialog() {
    this.loadingDialogRef?.close();
    this.loadingDialogRef = null;
  }
}
